import * as axios from "axios";

import { API } from "./config";

const getAllData = async function(api) {
  try {
    const response = await axios.get(api);
    let data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const parseList = response => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data;
  if (typeof list !== "object") {
    list = [];
  }
  return list;
};

export const data = {
  getAllData
};
